import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";

import { Link } from "@reach/router";

function Cat(props) {
  return (
    <div className={styles.queryBox}>
      <CloseButton setSelected={props.setSelected} />
      <div className={styles.questions}>
        <p>
          Hi I'm a cat, I live on Lydia Ann Street but I have mini homes and
          humans that feed me all over Ropewalks. Here’s the thing, do you know
          what? There are too many cars so it increases my chance of getting run
          over, Also there are a lot of mean drunk humans who treat us bad.
        </p>
        <p>
          Do us a favour, write an Incident report out for me, tell them human
          scousers they need to do something about this for cats sake!
        </p>
        <p>
          #staysafe #staysoberifyoucanthandleit #Dontspeed
          #lockupdrunkmeanhumans #carsofftheroad #splatcat #catrights
        </p>
      </div>
    </div>
  );
}

export default Cat;
